// extracted by mini-css-extract-plugin
export default {"container":"style_container__xDUL7","quickInput":"style_quickInput__xaRIG"};